import React, { useState, useRef, useEffect } from "react";

import { useFormCtx } from "./FormContext";
import useScreenType from "./hooks/useScreenType";

import * as Const from "./_Const";

import Navbar from "./components/Navbar";
import Button from "./components/Button";
import ScaleSpinnerProgressSection from "./components/ScaleSpinnerProgressSection";

function PageTestSoundLed() {
  const screenType = useScreenType();
  const [data, setData] = useState();
  const { getTerminalHwInfo, isTaskRunning, beep, playGong, setLedTo } = useFormCtx();

  useEffect(() => {
    async function scopedLoadData() {}

    scopedLoadData();
  }, []);

  return (
    <>
      <Navbar useCustomTitle={true} customTitle={"Testování zvuků a LED diody"} />
      {/* {(isTaskRunning || !data) && <ScaleSpinnerProgressSection />} */}
      {/* {!isTaskRunning && data && ( */}
      <div className="flex flex-col overflow-hidden h-[416px] scRPIV2:h-[624px] scWaveShare:h-[704px] tvFullHD:h-[704px] tv4K:h-[1404px] tvFullHD:mx-8 tv4K:mx-12 ">
        <p className="mx-6 mt-4 text-xl tvFullHD:text-4xl tvFullHD:mt-8 tvFullHD:mb-2  tv4K:text-6xl tv4K:mt-12 tv4K:mb-6 text-primary">Zvuk</p>
        <div className="overflow-y-auto grid grid-cols-2 mx-6 mt-4 mb-2 gap-4 tvFullHD:gap-8 tv4K:gap-12">
          {/* 1. radek  */}

          <Button
            title={"Info panel - přehrát zvuk"}
            showIcon={false}
            className="h-16 text-xs scRPIV2:h-20 scRPIV2:text-base scWaveShare:h-20 scWaveShare:text-base tvHD:h-20 tvHD:text-base tvFullHD:h-40 tvFullHD:text-2xl tv4K:h-80 tv4K:text-6xl"
            onClick={() => playGong(true)}
          />
          <Button
            title={"Terminál - přehrát zvuk"}
            showIcon={false}
            className="h-16 text-xs scRPIV2:h-20 scRPIV2:text-base scWaveShare:h-20 scWaveShare:text-base tvHD:h-20 tvHD:text-base tvFullHD:h-40 tvFullHD:text-2xl tv4K:h-80 tv4K:text-6xl"
            forceBeepDisabled={true}
            onClick={() => beep(1, true)}
          />
        </div>

        <p className="mx-6 mt-4 text-xl tvFullHD:text-4xl tvFullHD:mt-8 tvFullHD:mb-2  tv4K:text-6xl tv4K:mt-12 tv4K:mb-6 text-primary">
          LED - dioda v terminálu
        </p>
        <div className="overflow-y-auto grid grid-cols-2 mx-6 mt-4 mb-2 gap-4 tvFullHD:gap-8 tv4K:gap-12">
          {/* 2. radek  */}

          <Button
            title={"Dioda - rozvítit"}
            showIcon={false}
            className="h-16 text-xs scRPIV2:h-20 scRPIV2:text-base scWaveShare:h-20 scWaveShare:text-base tvHD:h-20 tvHD:text-base tvFullHD:h-40 tvFullHD:text-2xl tv4K:h-80 tv4K:text-6xl"
            onClick={() => setLedTo(Const.STATE_ENABLED)}
          />
          <Button
            title={"Dioda - zhasnout"}
            showIcon={false}
            className="h-16 text-xs scRPIV2:h-20 scRPIV2:text-base scWaveShare:h-20 scWaveShare:text-base tvHD:h-20 tvHD:text-base tvFullHD:h-40 tvFullHD:text-2xl tv4K:h-80 tv4K:text-6xl"
            onClick={() => setLedTo(Const.STATE_DISABLED)}
          />
        </div>
      </div>
      {/* )} */}
    </>
  );
}

export default PageTestSoundLed;
